export default __webpack_public_path__ + "static/media/personal-tax-icon.6b67e552.svg";